import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useShowDeliveryScheduleWarningModal } from "../../../../Checkout/DeliveryMethodSection/DeliveryMethodSectionUtils";
import { DeliveryScheduleRemappingText } from "../../DeliveryScheduleRemappingModal/utils/DSRM-typesAndEnums";
import { AccountRoutesType, Routes } from "../../Navigation/navigationUtils";
import { getAddressChangeClick } from "../utils/addressCardUtils";
export const useAddressCard_Button = (currentAddressCardData, orderInfo, setNewAddressData, address, orderId) => {
    const [showOrderRemappingModal, setShowOrderRemappingModal] = useState(false);
    const { showDeliveryScheduleWarningModal } = useShowDeliveryScheduleWarningModal();
    const { sku: flowSku } = useParams();
    const location = useLocation();
    const isCheckout = location.pathname.includes(Routes.CHECKOUT);
    const remappingModalTitle = location.pathname.includes(AccountRoutesType.SUBSCRIPTIONS)
        ? DeliveryScheduleRemappingText.UPDATE_SUBSCRIPTION
        : DeliveryScheduleRemappingText.UPDATE_ORDER;
    const onClick = getAddressChangeClick(isCheckout, currentAddressCardData, orderInfo, setNewAddressData, setShowOrderRemappingModal, showDeliveryScheduleWarningModal, address, flowSku, orderId);
    return {
        showOrderRemappingModal,
        setShowOrderRemappingModal,
        showDeliveryScheduleWarningModal,
        flowSku,
        remappingModalTitle,
        onClick,
    };
};
